import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Table, ListGroup, ListGroupItem } from "reactstrap";
import DatePicker from "react-date-picker";
import moment from "moment";
import CustomLoader from "../../component/CustomLoader/CustomLoader";

import {
  formatNumbers,
  isNetworkRequestFailedError,
} from "../../config/helpers";
import api from "../../config/api";
import historyActions from "../../redux/history/action";
import authActions from "../../redux/auth/action";
import accountInfoActions from "../../redux/accountInfo/action";
import "./style.css";
import editIcon from "../../assets/icons/edit.png";
import PageHead from "../../component/pageHead/PageHead";
class TransactionDetails extends Component {
  state = {
    from: new Date(),
    to: new Date(),
    contributions: [],
    isLoading: false,
    showCalender: true,
  };

  componentDidMount() {
    const { history, setHistory } = this.props;
    setHistory(history);
  }

  fetchContributions = async (type, newFrom) => {
    const { user, setAlertMessage, setTransactionDetailsValues, from, to } =
      this.props;
    if (newFrom !== "fixed" && (!from || !to)) return;

    try {
      if (newFrom !== "fixed" && moment(to).isBefore(newFrom)) {
        throw new Error("From date can not be higher than to");
      }

      this.setState({ isLoading: true });

      let startDate = moment(from).format("YYYY-MMMM-DD");
      let endDate = moment(to).format("YYYY-MMMM-DD");

      if (type === "this_year") {
        startDate = moment().startOf("year").format("YYYY-MMMM-DD");
        endDate = moment().format("YYYY-MMMM-DD");

        this.setState({ from: new Date(startDate), to: new Date(endDate) });
      }

      if (type === "last_year") {
        startDate = moment()
          .subtract(1, "year")
          .startOf("year")
          .format("YYYY-MMMM-DD");
        endDate = moment()
          .subtract(1, "year")
          .endOf("year")
          .format("YYYY-MMMM-DD");

        this.setState({ from: new Date(startDate), to: new Date(endDate) });
      }

      if (type === "quarter") {
        startDate = moment()
          .subtract(1, "quarter")
          .startOf("quarter")
          .format("YYYY-MMMM-DD");
        endDate = moment().format("YYYY-MMMM-DD");

        this.setState({ from: new Date(startDate), to: new Date(endDate) });
      }

      const body = {
        startDate,
        endDate,
        rsaPin: user.User.rsaPin,
      };

      const response = await api.fetchMemberContributions(body, user.token);

      this.setState({ contributions: response.data.result, isLoading: false });

      // let formatedStartDate = moment(from).format("MMMM-DD-YYYY");
      // let formatedEndDate = moment(to).format("MMMM-DD-YYYY");
      // console.log("formatedStartDate =>", formatedStartDate);
      // console.log("formatedEndDate =>", formatedEndDate);

      const reduxPayload = {
        input: {
          from: new Date(moment(from).valueOf()),
          to: new Date(moment(to).valueOf()),
        },
        contributions: response.data.result,
      };
      // return;

      setTransactionDetailsValues(reduxPayload);
    } catch (error) {
      console.log("this.fetchContributions =>", this.fetchContributions);

      setAlertMessage({
        type: "error",
        message: error.message,
        onTryAgain: isNetworkRequestFailedError(error)
          ? () => this.fetchContributions(type, newFrom)
          : null,
      });
      this.setState({ contributions: [], isLoading: false });
    }
  };

  handlePickerChange = (key, value) => {
    let { setTransactionDetailsValues, contributions, from, to } = this.props;
    if (key === "from" && moment(to).isBefore(value)) {
      this.setState({ showCalender: false }, () => {
        this.fetchContributions(null, value);
        this.setState({ showCalender: true });
      });
      return;
    }

    const reduxPayload = {
      contributions,
      input: {
        from,
        to,
      },
    };

    reduxPayload.input[key] = value;
    // reduxPayload.input.to = to;

    setTransactionDetailsValues(reduxPayload);

    this.setState({ [key]: value, to }, () =>
      this.fetchContributions(null, value)
    );
  };

  renderContributions = (contribution) => (
    <tr key={this.generateUniqueKey()}>
      {/* <td>{moment(contribution.VALUE_DATE).format("YY/MM/DD")}</td> */}
      <td>{contribution.Description}</td>
      <td className="text-right">
        {formatNumbers(contribution.EMPLOYEE, true)}
      </td>
      <td className="text-right">
        {formatNumbers(contribution.EMPLOYER, true)}
      </td>
      <td className="text-right">
        {formatNumbers(contribution.VOLUNTARY, true)}
      </td>
      <td className="text-right">{formatNumbers(contribution.TOTAL, true)}</td>
      <td className="text-right">
        {formatNumbers(contribution.Withdrawwal, true)}
      </td>
      {/* <td className="text-right">
        {formatNumbers(contribution.VOLUNTARY_UNITS)}
      </td>
      <td className="text-right">{formatNumbers(contribution.TOTAL_UNITS)}</td> */}
    </tr>
  );

  generateUniqueKey = () => `${Math.random()}${Math.random()}${Math.random()}`;

  render() {
    const { isLoading } = this.state;
    const { contributions, from, to } = this.props;

    return (
      <Container>
        <PageHead
          containerStyles={{ width: "100%" }}
          title="TRANSACTION DETAILS"
        />

        <ListGroup className="mt-2">
          <ListGroupItem className="transaction-details-picker-container">
            <p className="pr-1">Time Period</p>
            <div className="transaction-details-picker">
              {this.state.showCalender && (
                <DatePicker
                  calendarIcon={<CalenderIcon />}
                  calendarClassName="transaction-details-calender-main-container"
                  className="transaction-details-calender-field mx-1"
                  value={from}
                  format="M/d/yyyy"
                  onChange={(value) => this.handlePickerChange("from", value)}
                />
              )}
              {this.state.showCalender && (
                <DatePicker
                  calendarIcon={<CalenderIcon />}
                  calendarClassName="transaction-details-calender-main-container"
                  className="transaction-details-calender-field mr-1"
                  value={to}
                  minDate={from && new Date(moment(from))}
                  format="M/d/yyyy"
                  onChange={(value) => this.handlePickerChange("to", value)}
                />
              )}
            </div>
            <div className="transaction-details-calender-btns-container">
              <button
                className="transaction-details-calender-btn"
                onClick={this.fetchContributions.bind(
                  this,
                  "this_year",
                  "fixed"
                )}
              >
                This Year
              </button>
              <button
                className="transaction-details-calender-btn mx-1"
                onClick={this.fetchContributions.bind(
                  this,
                  "last_year",
                  "fixed"
                )}
              >
                Last Year
              </button>
              <button
                className="transaction-details-calender-btn"
                onClick={this.fetchContributions.bind(this, "quarter", "fixed")}
              >
                Last Quarter
              </button>
            </div>
          </ListGroupItem>
        </ListGroup>

        <Table bordered responsive className="transaction-details-table my-4">
          <thead>
            <tr className="headings">
              <th>Description</th>
              <th>Employee</th>
              <th>Employer</th>
              <th>Voluntary</th>
              <th>Total</th>
              <th>Withdrawal</th>
            </tr>
          </thead>
          <tbody>
            {contributions.map((item) => this.renderContributions(item))}
          </tbody>
        </Table>
        {isLoading && <CustomLoader />}
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  from: state.accountInfo.transactionDetails.input.from,
  to: state.accountInfo.transactionDetails.input.to,
  contributions: state.accountInfo.transactionDetails.contributions,
});

const mapDispatchToProps = {
  setHistory: historyActions.setHistory,
  setAlertMessage: authActions.setAlertMessage,
  setTransactionDetailsValues: accountInfoActions.setTransactionDetailsValues,
};

export default connect(mapStateToProps, mapDispatchToProps)(TransactionDetails);

function CalenderIcon() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img alt="edit-icon" src={editIcon} width="20px" />
    </div>
  );
}
